import React, { useState } from "react";
import LineEllipsis from "react-lines-ellipsis";
import Tooltip from "src/components/tooltip";
import { Placement } from "react-bootstrap/esm/types";
import cx from "classnames";

interface TextClampedProps {
    text: string;
    tooltipContent?: React.ReactNode;
    maxLine?: string | number;
    placement?: Placement;
    classnames?: string;
    basedOn?: "words" | "letters";
}

export const TextClamp: React.FC<TextClampedProps> = ({
    text,
    tooltipContent,
    maxLine = "1",
    placement = "top",
    classnames,
    basedOn = "words",
}) => {
    const [isClamped, setIsClamped] = useState(false);

    return (
        <Tooltip
            content={tooltipContent ?? text}
            placement={placement}
            disabled={!isClamped}
        >
            <span className={cx(classnames)}>
                <LineEllipsis
                    style={{ whiteSpace: 'pre-wrap' }}
                    text={text || ""}
                    maxLine={maxLine}
                    ellipsis="..."
                    trimRight
                    basedOn={basedOn}
                    onReflow={({ clamped }) => setIsClamped(clamped)}
                />
            </span>
        </Tooltip>
    );
};